import { asyncRouterMap, constantRouterMap } from '@/router/index';

//判断是否有权限访问该菜单
function hasPermission(menus, route, roles) {
  if (route.name) {
    let currMenu = getMenu(route.name, menus);
    if (currMenu!=null) {
      //设置菜单的标题、图标和可见性
      if (currMenu.title != null && currMenu.title !== '') {
        route.meta.title = currMenu.title;
      }
      if (currMenu.icon != null && currMenu.title !== '') {
        route.meta.icon = currMenu.icon;
      }
      if(currMenu.hidden!=null){
        route.hidden = currMenu.hidden !== 0;
      }
      if (currMenu.sort != null && currMenu.sort !== '') {
        route.sort = currMenu.sort;
      }
      //设置管理员账号enableDeletingAuth
      if(roles && roles.includes("超级管理员") && route.props) {
        // if(route.props.enableDeletingAuth == false) {
        //   console.log("测试", route.props)
        //   route.props.enableDeletingAuth = true;
        //   console.log("测试", route.props)
        // }
        
      }

      return true;
    } else {
      route.sort = 0;
      if (route.hidden !== undefined && route.hidden === true) {
        route.sort=-1;
        return true;
      } else {
        // 如果是有子路由的容器路由（没有component或component是简单的router-view），允许通过
        // 这样可以支持二级目录，子路由需要单独配置权限
        if (route.children && route.children.length > 0 && !route.component.name) {
          return true;
        }
        return false;
      }
    }
  } else {
    return true
  }
}

//根据路由名称获取菜单
function getMenu(name, menus) {
  for (let i = 0; i < menus.length; i++) {
    let menu = menus[i];
    if (name===menu.name) {
      return menu;
    }
    // 递归查找子菜单
    if (menu.children && menu.children.length > 0) {
      let found = getMenu(name, menu.children);
      if (found) {
        return found;
      }
    }
  }
  return null;
}

//对菜单进行排序
function sortRouters(accessedRouters) {
  for (let i = 0; i < accessedRouters.length; i++) {
    let router = accessedRouters[i];
    if(router.children && router.children.length > 0){
      router.children.sort(compare("sort"));
    }
  }
  accessedRouters.sort(compare("sort"));
}

//降序比较函数
function compare(p){
  return function(m,n){
    let a = m[p];
    let b = n[p];
    return b - a;
  }
}

//计算路由数量（包括子路由）
function countRoutes(routers) {
  let count = 0;
  routers.forEach(router => {
    if (!router.hidden) {
      count++;
      if (router.children && router.children.length > 0) {
        count += countRoutes(router.children);
      }
    }
  });
  return count;
}

const permission = {
  state: {
    routers: constantRouterMap,
    addRouters: [],
    permissionPageCount: 0
  },
  mutations: {
    SET_ROUTERS: (state, routers) => {
      state.addRouters = routers;
      state.routers = constantRouterMap.concat(routers);
    },
    SET_PERMISSION_PAGE_COUNT: (state, count) => {
      state.permissionPageCount = count;
    }
  },
  actions: {
    GenerateRoutes({ commit }, data) {
      return new Promise(resolve => {
        const { menus } = data;
        const { username, roles } = data;
        
        // 递归过滤路由权限
        function filterRoutes(routes, menus, roles) {
          return routes.filter(route => {
            if (hasPermission(menus, route, roles)) {
              if (route.children && route.children.length > 0) {
                route.children = filterRoutes(route.children, menus, roles);
                // 如果所有子节点都被过滤掉，父节点也不显示
                if (route.children.length === 0) {
                  return false;
                }
              }
              return true;
            }
            return false;
          });
        }

        // 过滤出有权限的路由
        const accessedRouters = filterRoutes(asyncRouterMap, menus, roles);

        // 排序路由
        sortRouters(accessedRouters);
        commit('SET_ROUTERS', accessedRouters);
        // 计算路由数量并设置导航类型
        const pageCount = countRoutes(accessedRouters);
        commit('SET_PERMISSION_PAGE_COUNT', pageCount);
        // 设置导航类型
        const navType = pageCount <= 5 ? 'top' : 'side';
        // 调用app模块的SET_NAV_TYPE mutation（使用root commit）
        commit('SET_NAV_TYPE', navType, { root: true });
        resolve(accessedRouters);
      });
    }
  },
  
};

export default permission;




// WEBPACK FOOTER //
// ./src/store/modules/permission.js